import React, { useCallback, useEffect, useRef, useState } from "react"
import { COLORS } from "../../../utilities/Constants"
import { getPhotoFromFile } from "../../../utilities/Addons"
import { consommerEchap } from "../../../utilities/echapFiche"

export const AppPhotoThumbnail = ({
	photo,
	onDelete,
	onClick = (index) => {},
	index = 0,
	readOnly = false,
}) => {
	const [hovered, setHovered] = useState(false)

	return (
		<>
			<div
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
				style={{
					position: "relative",
					width: 90,
					height: 90,
					borderRadius: 10,
					overflow: "hidden",
					border: `1px solid ${COLORS.border}`,
					flexShrink: 0,
					cursor: "pointer",
				}}
			>
				<img
					onClick={() => onClick(index)}
					src={photo.url}
					alt={photo.name}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
						display: "block",
						transition: "transform 0.2s",
						transform: hovered ? "scale(1.05)" : "scale(1)",
					}}
				/>
				{hovered && !readOnly && (
					<div
						style={{
							position: "absolute",
							top: 0,
							right: 0,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<button
							onClick={() => onDelete(photo)}
							style={{
								width: 28,
								height: 28,
								borderRadius: "50%",
								border: "none",
								backgroundColor: COLORS.danger,
								color: "#fff",
								fontSize: 16,
								cursor: "pointer",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontWeight: 300,
								lineHeight: 1,
							}}
						>
							×
						</button>
					</div>
				)}
				<div
					style={{
						position: "absolute",
						bottom: 0,
						left: 0,
						right: 0,
						padding: "3px 5px",
						backgroundColor: "rgba(28,25,23,0.6)",
						fontSize: 9,
						color: "#fff",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				>
					{photo.name}
				</div>
			</div>
		</>
	)
}
// `readOnly` (fiche close, Jordan 30.10) : consultation seule — ni ajout
// (bouton, tuile « + »), ni suppression ; les vignettes s'ouvrent toujours.
export const AppPhotoSection = ({
	title,
	accent,
	photos,
	onUpload,
	onDelete,
	onClickPhoto,
	readOnly = false,
}) => {
	const inputRef = useRef(null)

	const handleFiles = (e) => {
		const files = Array.from(e.target.files)
		const newPhotos = files.map((file) => getPhotoFromFile(file))
		onUpload(newPhotos)
		e.target.value = ""
	}

	return (
		<div
			style={{
				flex: 1,
				display: "flex",
				flexDirection: "column",
				gap: 12,
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					<div
						style={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: accent,
							flexShrink: 0,
						}}
					/>
					<span
						style={{
							fontSize: 13,
							fontWeight: 500,
							color: COLORS.text,
						}}
					>
						{title}
					</span>
					{photos.length > 0 && (
						<span
							style={{
								fontSize: 11,
								color: COLORS.textLight,
								backgroundColor: COLORS.bg,
								border: `1px solid ${COLORS.border}`,
								borderRadius: 99,
								padding: "1px 8px",
							}}
						>
							{photos.length}
						</span>
					)}
				</div>
				{!readOnly && (
					<button
						onClick={() => inputRef.current?.click()}
						style={{
							display: "flex",
							alignItems: "center",
							gap: 5,
							padding: "5px 12px",
							borderRadius: 8,
							border: `1px solid ${COLORS.border}`,
							backgroundColor: COLORS.surface,
							color: COLORS.textMuted,
							fontSize: 12,
							fontWeight: 500,
							cursor: "pointer",
							fontFamily: "inherit",
							transition: "all 0.15s",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.borderColor =
								COLORS.borderStrong
							e.currentTarget.style.color = COLORS.text
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.borderColor = COLORS.border
							e.currentTarget.style.color = COLORS.textMuted
						}}
					>
						+ Ajouter
					</button>
				)}
				<input
					ref={inputRef}
					type="file"
					accept="image/*"
					multiple
					onChange={handleFiles}
					style={{ display: "none" }}
				/>
			</div>

			{photos.length === 0 && readOnly ? (
				<span style={{ fontSize: 12, color: COLORS.textMuted }}>
					Aucune photo
				</span>
			) : photos.length === 0 ? (
				<div
					onClick={() => inputRef.current?.click()}
					style={{
						border: `1px dashed ${COLORS.borderStrong}`,
						borderRadius: 10,
						padding: "24px 16px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						gap: 6,
						cursor: "pointer",
						backgroundColor: COLORS.bg,
						transition: "all 0.15s",
					}}
					onMouseEnter={(e) =>
						(e.currentTarget.style.backgroundColor = COLORS.surface)
					}
					onMouseLeave={(e) =>
						(e.currentTarget.style.backgroundColor = COLORS.bg)
					}
				>
					<span style={{ fontSize: 22 }}>📷</span>
					<span style={{ fontSize: 12, color: COLORS.textMuted }}>
						Cliquez pour ajouter des photos
					</span>
				</div>
			) : (
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						gap: 8,
					}}
				>
					{photos.map((photo, index) => (
						<AppPhotoThumbnail
							key={photo.id}
							photo={photo}
							onDelete={onDelete}
							onClick={onClickPhoto}
							index={index}
							readOnly={readOnly}
						/>
					))}
					{!readOnly && (
						<div
							onClick={() => inputRef.current?.click()}
							style={{
								width: 90,
								height: 90,
								borderRadius: 10,
								border: `1px dashed ${COLORS.borderStrong}`,
								backgroundColor: COLORS.bg,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
								fontSize: 22,
								color: COLORS.textLight,
								flexShrink: 0,
								transition: "all 0.15s",
							}}
							onMouseEnter={(e) =>
								(e.currentTarget.style.backgroundColor =
									COLORS.surface)
							}
							onMouseLeave={(e) =>
								(e.currentTarget.style.backgroundColor =
									COLORS.bg)
							}
						>
							+
						</div>
					)}
				</div>
			)}
		</div>
	)
}

export default function AppPhotosViewer({
	images,
	currentIndex,
	onClose,
	onNavigate,
}) {
	const hasPrev = currentIndex > 0
	const hasNext = currentIndex < images.length - 1
	const current = images[currentIndex]

	const handlePrev = useCallback(() => {
		if (hasPrev) onNavigate(currentIndex - 1)
	}, [hasPrev, currentIndex, onNavigate])

	const handleNext = useCallback(() => {
		if (hasNext) onNavigate(currentIndex + 1)
	}, [hasNext, currentIndex, onNavigate])

	useEffect(() => {
		const handleKey = (e) => {
			if (e.key === "Escape") {
				consommerEchap(e)
				onClose()
			}
			if (e.key === "ArrowLeft") handlePrev()
			if (e.key === "ArrowRight") handleNext()
		}
		window.addEventListener("keydown", handleKey)
		return () => window.removeEventListener("keydown", handleKey)
	}, [handlePrev, handleNext, onClose])

	if (!current) return null

	return (
		// Marqueur : Échap des fiches ignoré visionneuse ouverte (echapFiche).
		<div
			data-visionneuse=""
			onClick={onClose}
			style={{
				position: "fixed",
				inset: 0,
				backgroundColor: "rgba(28, 25, 23, 0.85)",
				backdropFilter: "blur(8px)",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				zIndex: 1000,
				padding: 24,
			}}
		>
			{/* Modal */}
			<div
				onClick={(e) => e.stopPropagation()}
				style={{
					backgroundColor: COLORS.surface,
					borderRadius: 20,
					border: `1px solid ${COLORS.border}`,
					boxShadow: "0 32px 64px rgba(28, 25, 23, 0.25)",
					width: "100%",
					maxWidth: 860,
					maxHeight: "90vh",
					overflow: "hidden",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{/* Header */}
				<div
					style={{
						padding: "12px 16px",
						borderBottom: `1px solid ${COLORS.border}`,
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						backgroundColor: "#F5F3EF",
						flexShrink: 0,
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 10,
						}}
					>
						<span
							style={{
								fontSize: 13,
								fontWeight: 500,
								color: COLORS.text,
							}}
						>
							{current.name || `Photo ${currentIndex + 1}`}
						</span>
						{current.type && (
							<span
								style={{
									fontSize: 11,
									fontWeight: 500,
									padding: "2px 10px",
									borderRadius: 99,
									backgroundColor:
										current.type === "avant"
											? "#EFF6FF"
											: "#F0FDF4",
									color:
										current.type === "avant"
											? "#2563EB"
											: "#16A34A",
									border: `1px solid ${current.type === "avant" ? "#BFDBFE" : "#BBF7D0"}`,
								}}
							>
								{current.type === "avant" ? "Avant" : "Après"}
							</span>
						)}
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 10,
						}}
					>
						<span style={{ fontSize: 12, color: COLORS.textLight }}>
							{currentIndex + 1} / {images.length}
						</span>
						<button
							onClick={onClose}
							style={{
								width: 32,
								height: 32,
								borderRadius: 8,
								border: `1px solid ${COLORS.border}`,
								backgroundColor: COLORS.surface,
								color: COLORS.textMuted,
								cursor: "pointer",
								fontSize: 18,
								fontWeight: 300,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								lineHeight: 1,
							}}
						>
							×
						</button>
					</div>
				</div>

				{/* Image + Arrows */}
				<div
					style={{
						position: "relative",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#1C1917",
						flex: 1,
						minHeight: 0,
						overflow: "hidden",
					}}
				>
					{/* Prev */}
					<button
						onClick={handlePrev}
						disabled={!hasPrev}
						style={{
							position: "absolute",
							left: 16,
							zIndex: 10,
							width: 44,
							height: 44,
							borderRadius: 12,
							border: "none",
							backgroundColor: hasPrev
								? "rgba(28,25,23,0.75)"
								: "rgba(28,25,23,0.2)",
							color: hasPrev ? "#fff" : "rgba(255,255,255,0.3)",
							fontSize: 20,
							cursor: hasPrev ? "pointer" : "default",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							transition: "all 0.15s",
						}}
						onMouseEnter={(e) => {
							if (hasPrev)
								e.currentTarget.style.backgroundColor =
									"rgba(28,25,23,0.95)"
						}}
						onMouseLeave={(e) => {
							if (hasPrev)
								e.currentTarget.style.backgroundColor =
									"rgba(28,25,23,0.75)"
						}}
					>
						‹
					</button>

					{/* Image */}
					<img
						key={current.preview || current.url}
						src={current.preview || current.url}
						alt={current.name}
						style={{
							maxWidth: "100%",
							maxHeight: "70vh",
							objectFit: "contain",
							display: "block",
							userSelect: "none",
						}}
					/>

					{/* Next */}
					<button
						onClick={handleNext}
						disabled={!hasNext}
						style={{
							position: "absolute",
							right: 16,
							zIndex: 10,
							width: 44,
							height: 44,
							borderRadius: 12,
							border: "none",
							backgroundColor: hasNext
								? "rgba(28,25,23,0.75)"
								: "rgba(28,25,23,0.2)",
							color: hasNext ? "#fff" : "rgba(255,255,255,0.3)",
							fontSize: 20,
							cursor: hasNext ? "pointer" : "default",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							transition: "all 0.15s",
						}}
						onMouseEnter={(e) => {
							if (hasNext)
								e.currentTarget.style.backgroundColor =
									"rgba(28,25,23,0.95)"
						}}
						onMouseLeave={(e) => {
							if (hasNext)
								e.currentTarget.style.backgroundColor =
									"rgba(28,25,23,0.75)"
						}}
					>
						›
					</button>
				</div>

				{/* Thumbnails */}
				{images.length > 1 && (
					<div
						style={{
							padding: "10px 16px",
							borderTop: `1px solid ${COLORS.border}`,
							display: "flex",
							gap: 8,
							overflowX: "auto",
							backgroundColor: "#F5F3EF",
							flexShrink: 0,
						}}
					>
						{images.map((img, i) => (
							<div
								key={i}
								onClick={() => onNavigate(i)}
								style={{
									width: 52,
									height: 52,
									borderRadius: 8,
									overflow: "hidden",
									flexShrink: 0,
									cursor: "pointer",
									border:
										i === currentIndex
											? `2px solid ${COLORS.text}`
											: `2px solid transparent`,
									opacity: i === currentIndex ? 1 : 0.5,
									transition: "all 0.15s",
								}}
								onMouseEnter={(e) => {
									if (i !== currentIndex)
										e.currentTarget.style.opacity = "0.8"
								}}
								onMouseLeave={(e) => {
									if (i !== currentIndex)
										e.currentTarget.style.opacity = "0.5"
								}}
							>
								<img
									src={img.preview || img.url}
									alt={img.name}
									style={{
										width: "100%",
										height: "100%",
										objectFit: "cover",
									}}
								/>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	)
}
